import React from 'react';
import { Skeleton } from './Skeleton';

/**
 * Skeleton Table - for table loading states
 * Matches the exact layout to prevent layout shifts
 */
export const SkeletonTable = ({
  rows = 5,
  columns = 4,
  hasActions = true,
  className = ''
}) => {
  return (
    <div className={`skeleton-table ${className}`} style={{ width: '100%' }}>
      {/* Table Header */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: hasActions
            ? `repeat(${columns}, 1fr) 100px`
            : `repeat(${columns}, 1fr)`,
          gap: '1rem',
          padding: '1rem',
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: 'var(--color-surface-alt, #f8fafc)'
        }}
      >
        {Array.from({ length: columns }).map((_, index) => (
          <Skeleton
            key={`header-${index}`}
            width="80%"
            height="1rem"
          />
        ))}
        {hasActions && <Skeleton width="60px" height="1rem" />}
      </div>

      {/* Table Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={`row-${rowIndex}`}
          style={{
            display: 'grid',
            gridTemplateColumns: hasActions
              ? `repeat(${columns}, 1fr) 100px`
              : `repeat(${columns}, 1fr)`,
            gap: '1rem',
            padding: '1rem',
            borderBottom: '1px solid #e2e8f0'
          }}
        >
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton
              key={`cell-${rowIndex}-${colIndex}`}
              width={colIndex === 0 ? '90%' : '70%'}
              height="1rem"
            />
          ))}
          {hasActions && (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Skeleton width="32px" height="32px" borderRadius="4px" />
              <Skeleton width="32px" height="32px" borderRadius="4px" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

/**
 * Skeleton List - for list items with avatar
 */
export const SkeletonList = ({
  items = 5,
  hasAvatar = true,
  hasSecondaryText = true,
  hasActions = true,
  className = ''
}) => {
  return (
    <div className={`skeleton-list ${className}`}>
      {Array.from({ length: items }).map((_, index) => (
        <div
          key={`list-item-${index}`}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            padding: '1rem',
            borderBottom: '1px solid #e2e8f0'
          }}
        >
          {hasAvatar && <Skeleton variant="circular" height="40px" />}
          <div style={{ flex: 1 }}>
            <Skeleton width="60%" height="1rem" style={{ marginBottom: '0.5rem' }} />
            {hasSecondaryText && <Skeleton width="40%" height="0.875rem" />}
          </div>
          {hasActions && (
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <Skeleton width="32px" height="32px" borderRadius="4px" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default SkeletonTable;
